/*!
    * @product/scmp-sdk 1.0.191
    * 2ee70241639e6ca63aaacf31294551dd6dda7662
  */
function i(...d){var n,a;typeof window>"u"||!((n=window)!==null&&n!==void 0&&(a=n.dataLayer)!==null&&a!==void 0&&a.push)||window.dataLayer.push(arguments)}export{i as a};
//# sourceMappingURL=chunk-AK47B2K3.js.map
